export default "__VITE_ASSET__DASCt1Gl__"